import { createReducer, on } from '@ngrx/store';
import {
  setSelectedBrand,
  setSelectedLocations,
  setSelectedLocationsObject,
  setLocationListFilters,
  resetLocationListFilters,
  LocationListFilters,
} from '@app/modules/locations/store/locations-actions';
import { GeoKLocationLight } from '@app/shared/models/geo-k-location';

export const locationsKey = 'locations';

export interface LocationsState {
  brandId: string;
  selectedLocations: string[];
  selectedLocationsObjects: GeoKLocationLight[];
  locationListFilters: LocationListFilters | null;
}

export const initialState: LocationsState = {
  brandId: '',
  selectedLocations: [],
  selectedLocationsObjects: [],
  locationListFilters: null,
};
export const LocationsReducer = createReducer(
  initialState,
  on(setSelectedBrand, (state: LocationsState, { brandId }) => ({
    ...state,
    brandId: brandId,
  })),

  on(setSelectedLocations, (state: LocationsState, { locationIds }) => ({
    ...state,
    selectedLocations: locationIds,
  })),

  on(setSelectedLocationsObject, (state: LocationsState, { locations }) => ({
    ...state,
    selectedLocationsObjects: locations,
    selectedLocations: locations.map((lc) => lc.id),
  })),

  on(setLocationListFilters, (state: LocationsState, { filters }) => ({
    ...state,
    locationListFilters: filters,
  })),

  on(resetLocationListFilters, (state: LocationsState) => ({
    ...state,
    locationListFilters: null,
  }))
);
